// @flow
import React from 'react';
import ReactDatePicker from 'react-date-picker';

import styles from './datePicker.css';


type DatePickerPropTypes = {
  size?: string,
  value?: Date,
  onChange?: Function
};

class DatePicker extends React.Component<DatePickerPropTypes> {
  constructor(props: DatePickerPropTypes) {
    super(props);

    return props.onChange && props.onChange(props.value || new Date());
  }

  render() {
    const { size = 'medium', ...props } = this.props;
    return <ReactDatePicker
      {...props}
      className={
        `
          ${styles.datePicker}
          ${typeof styles[size] !== 'undefined' ? styles[size] : ''}
        `
      }
      calendarClassName={styles.calendar}
      value={props.value}
    />;
  }
}


export default DatePicker;



// WEBPACK FOOTER //
// ./src/scripts/components/DatePicker/index.jsx